import React, { useEffect } from 'react';
import { Card, Row, Col, Statistic, Result, Button } from 'antd';
// import { cardDeckCols } from '../../utils/DataUtils';
import { motion } from 'motion/react';
import Masonry from 'react-layout-masonry';
import ShowCard from '../../components/ShowCard';
import ShowCardColors from '../../components/ShowCardColors';
import { useTranslation } from 'react-i18next';
import { orderedCardTypes, sortDeckByCardType, pluralizeCardType } from '../../utils/DataUtils';

function Deck(props) {
  // console.warn('props di deck: ',props);
  const [deck, setDeck] = React.useState({});
  const [decklist, setDecklist] = React.useState({mainboard: [], sideboard: []});
  const [hoveredItem, setHoveredItem] = React.useState(null);
  const [loading, setLoading] = React.useState(true);
  const [width, setWidth] = React.useState(window.innerWidth);
  const { t } = useTranslation();
  const isMobile = width <= 768;
  // let navigate = useNavigate();

  function calculateColumns(isMobile) {
    if (isMobile) {
      // console.warn('mobile: ', isMobile);
      return 1;
    }
    // console.warn('desktop: ', !isMobile);
    return 2;
  }

  function handleWindowSizeChange() {
      setWidth(window.innerWidth);
  }

  // function to elaborate decklist extracting card types from a list and generating an array of labels for each type
  function extractCardTypes(decklist) {
    const cardTypes = [];
    decklist.forEach((item) => {
      if (item.card && item.card.types) {
        item.card.types.forEach((type) => {
          if (!cardTypes.includes(type)) {
            cardTypes.push(type);
          }
        });
      }
    });
    return cardTypes;
  }

  const downloadTxtFile = (deck) => {
    // console.warn('downloading this deck:', deck)
    const element = document.createElement("a");
    const file = new Blob([deck.TxtDeckList], {type: 'text/plain'});
    element.href = URL.createObjectURL(file);
    element.download = props.id+".txt";
    document.body.appendChild(element); // Required for this to work in FireFox
    element.click();
  }

  useEffect(() => {
    if (props.deck.data && props.deck.data.pending !== false) {
      // console.warn('deck fulfilled but pending?', props.deck);
      let decklist = {mainboard: [], sideboard: []};
      setDeck(props.deck.data.payLoad);
      if (props.deck.data.payLoad.deckList) {
        if (props.deck.data.payLoad.deckList.mainboard != null) {
          decklist.mainboard = sortDeckByCardType(props.deck.data.payLoad.deckList.mainboard);
        }
        if (props.deck.data.payLoad.deckList.sideboard != null) {
          decklist.sideboard = props.deck.data.payLoad.deckList.sideboard;
        }
        // console.warn('decklist: ', decklist);
      }
      setDecklist(decklist);
      setLoading(false);
    }
    window.addEventListener('resize', handleWindowSizeChange);
    return () => {
        window.removeEventListener('resize', handleWindowSizeChange);
    }
  }, [props]);

  if (props.deck.data &&props.deck.data.errorMsg && props.deck.data.errorMsg !== '') {
    // console.warn('deck error: ', props.deck.errorMsg);
    return (
      <motion.div initial={{opacity: 0}} animate={{opacity: 1}} exit={{opacity: 0}} className="content-body">
        <Card loading={loading} style={{ marginTop: '24px' }}>
          <Result
            status="403"
            title="Forbidden"
            subTitle={props.deck.data.errorMsg}
          />
        </Card>
      </motion.div>
    );
  }
    // console.warn('deck error: ', props.deck.error);  
    // console.warn('decklist: ', decklist.mainboard);
  return (
    <motion.div initial={{opacity: 0}} animate={{opacity: 1}} exit={{opacity: 0}} className="content-body">
    <Card loading={loading} title={deck.deckName} style={{ marginTop: '24px' }}>
      <Row gutter={16}>
        <Col span={12}>
            <Statistic title="Link" value={deck.deckLink || 'Not Available'} />
        </Col>
        <Col span={12}>
            <Button onClick={(e) => {e.preventDefault(); downloadTxtFile(deck)}}>{t('decks.export')}</Button>
        </Col>
      </Row>
      <Row gutter={16} style={{ marginTop: '24px' }}>
        <Col xs={12} sm={12} md={6} lg={12} xl={12}>
          <p style={{ fontWeight: 'bold', textAlign: 'left', borderBottom: '1px solid #eee' }}>Mainboard ({decklist.mainboard.reduce((acc, item) => acc + item.quantity, 0)})</p>
          <Masonry columns={calculateColumns(isMobile)} gap={8}>
            {orderedCardTypes.map((type, index) => {
              const cardsOfType = decklist.mainboard.filter((card) => {
                if (type !== 'Land' && type !== 'Creature') {
                  // console.warn('filtering cards of type ', type, ' from card: ', card.card.name, ' with type_line: ', card.card.type_line);
                  return card.card.type_line.includes(type) && !card.card.type_line.includes('Land') && !card.card.type_line.includes('Creature');
                }
                if (type === 'Land') {
                  return card.card.type_line.includes(type) && !card.card.type_line.includes('Creature');
                }
                if (type === 'Creature') {
                  // console.warn('filtering cards of type ', type, ' from card: ', card.card.name, ' with type_line: ', card.card.type_line);
                  return card.card.type_line.includes(type)
                }
                // return card.card.type_line.includes(type);
              });
              // console.warn('cardsOfType ', cardsOfType, ' found for type ', type);
              if (cardsOfType.length === 0) return null;
              const cardsOfTypeQuantity = cardsOfType.reduce((acc, item) => acc + item.quantity, 0);
              return (
                <div key={`${type}-${index}`} id={`${type}-${index}`}>
                  <p style={{ fontWeight: 'bold', textAlign: 'left', marginBottom: '5px', marginTop: '5px' }}>{pluralizeCardType(type, cardsOfTypeQuantity)}</p>
                  {cardsOfType.map((item) => {
                    // console.warn('item: ', item);
                    if (item.card.hasErrors) {
                      return <p className="card-error" style={{ textAlign: 'left' }} onMouseEnter={() => setHoveredItem(null)}>{item.quantity} - {item.card.name}</p>;
                    }
                    return <p className="deck-card-name" onMouseEnter={() => setHoveredItem(item.card)}>{item.quantity} {item.card.name} <ShowCardColors card={item.card} /></p>;
                  })}
                </div>
              );
            })}
          </Masonry>
        </Col>
        <Col xs={12} sm={12} md={6} lg={6} xl={6}>
          <p style={{ fontWeight: 'bold', textAlign: 'left', borderBottom: '1px solid #eee' }}>Sideboard ({decklist.sideboard.reduce((acc, item) => acc + item.quantity, 0)})</p>
          <Masonry columns={1} gap={8}>
            <div>
              {decklist.sideboard.map((item) => {
                if (item.card.hasErrors) {
                  return <p className="card-error" style={{ textAlign: 'left' }} onMouseEnter={() => setHoveredItem(null)}>{item.quantity} - {item.card.name}</p>;
                }
                return <p className="deck-card-name" onMouseEnter={() => setHoveredItem(item.card)}>{item.quantity} {item.card.name} <ShowCardColors card={item.card} /></p>;
              })}
            </div>
          </Masonry>
        </Col>
        <Col xs={24} sm={24} md={6} lg={6} xl={6}>
          <ShowCard item={hoveredItem} />
        </Col>
      </Row>
    </Card>
    </motion.div>
  );
}

export default Deck;